import React, { useEffect } from 'react';
// import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import { connect } from 'react-redux';
import Errors from '~/components/Errors/Errors';
import Layout from '~/components/Layouts/LayoutBasic/LayoutBasic';
import Breadcrumb from '~/components/tuan/Breadcrumb/Breadcrumb';
import DownApp from '~/components/DownApp/DownApp';
import Card from '~/components/tuan/Card/Card';
import Tabs from '~/components/tuan/Tabs/Tabs';
import Recommend from '~/components/tuan/Recommend/Recommend';

import css from '~/styles/tuan/tuan.less';

const Tuan = props => {
  const updateOrders = page => {
    const { tuan, dispatch } = props;
    const { total } = tuan;
    if (page < 1 || page > total) {
      return false;
    }
    dispatch({
      type: 'tuan/updateOrders',
      payload: { page },
    });
    return true;
  };

  useEffect(() => {
    const { query } = props;
    const id = parseInt(query.id, 10);
    if (!id) {
      window.location.href = '/';
    }
  }, []);

  const { tuan, asPath } = props;
  const path = asPath.split('?')[0];
  const url = `${process.env.API_URL}${path}`;
  const { product, status } = tuan;
  const title = `${product.title} - 新得宝贝` || '新得宝贝 - 母婴服务放心选';
  if (status !== 0) {
    return <Errors statusCode={404} />;
  }
  return (
    <Layout>
      <NextSeo
        title={title}
        description="新得宝贝 - 母婴服务放心选"
        canonical={url}
        openGraph={{
          type: 'product',
          url,
          title,
          images: [
            {
              url: product.cover_url || '',
            },
          ],
          site_name: '新得宝贝',
        }}
      />
      <div className={css.contentMain}>
        <div className={css.main}>
          {/* 面包屑导航组件 */}
          <Breadcrumb />
          {/* 商品基础信息组件 */}
          <Card />
          <Tabs updateOrders={updateOrders} />
        </div>
        <div className={css.fixedQrcode}>
          {/* 右侧小程序二维码组件 */}
          <DownApp />
          {/* 右侧推荐产品列表 */}
          <Recommend />
        </div>
      </div>
    </Layout>
  );
};

Tuan.getInitialProps = async ({ pathname, query, dvaStore, asPath }) => {
  // dispatch effects to fetch data here
  const id = parseInt(query.id, 10);
  if (id) {
    query.id = id;
    query.cid = parseInt(query.cid, 10) || '';
    query.type = parseInt(query.type, 10) || '';
    await dvaStore.dispatch({ type: 'tuan/init', payload: { ...query } });
    await dvaStore.dispatch({ type: 'tuan/getTuan' });
    await dvaStore.dispatch({ type: 'tuan/getOrders' });
  }
  return {
    pathname,
    query,
    dvaStore,
    asPath,
  };
};

export default connect(({ tuan }) => ({
  tuan,
}))(Tuan);
